module.exports = __webpack_public_path__ + "static/media/jackpots-lvl3.e1534c0e.png";